<template>
    <div>
        <a-table :columns="columns" :data-source="dataList" :pagination="false" rowKey="trip_id"
            :loading="dataListLoading" :scroll="{ x: x, y: y }">
            <template slot="department.department_name" slot-scope="department_name">
                <a-tag>{{ department_name }}</a-tag>
            </template>
            <template slot="is_lock" slot-scope="is_lock">
                <a-tag :color="is_lock == 1 ? 'green' : 'red'">{{ is_lock == 1 ? '未锁单' : '已锁单' }}</a-tag>
            </template>
            <template slot="playindextext" slot-scope="playindextext, row">
                <a-tag :color="row.playindex == 0 ? 'red' : 'green'">{{ playindextext }}</a-tag>
            </template>
            <template slot="is_over_text" slot-scope="is_over_text, row">
                <a-tag :color="row.is_over == 2 ? 'red' : 'green'">{{ is_over_text }}</a-tag>
            </template>
            <template slot="person" slot-scope="text, row">
                <div class="pb-5">销售: {{ row.person_1 ? row.person_1info.real_name : '' }} <a-tag color="red"
                        v-if="!row || !row.person_1">未设置</a-tag> </div>
                <div class="pb-5">计调: {{ row.person_2 ? row.person_2info.real_name : '' }} <a-tag color="red"
                        v-if="!row || !row.person_2">未设置</a-tag> </div>
                <div>运营: {{ row.person_3 ? row.person_3info.real_name : '' }} <a-tag color="red"
                        v-if="!row || !row.person_3">未设置</a-tag>
                </div>
            </template>
            <template slot="trip_days2" slot-scope="trip_days2, row">
                第 {{row.trip_days.split(",").findIndex(v => v == todaytext) + 1}}天
            </template>
            <template slot="editBtn" slot-scope="text, row">
                <a-button type="link" class="p-5" @click="$emit('suodan', row.trip_id)"
                    v-permission="['admin:trip:lock']">
                    {{ row.is_lock == 1 ? '锁单' : '解除锁单' }}
                </a-button>
                <a-button type="link" class="p-5" v-permission="['admin:trip:update']"
                    @click="$emit('addOrUpdateHandle', { trip_id: row.trip_id, customer_id: row.customer_id })">
                    编辑
                </a-button>
                <a-button type="link" class="p-5" v-permission="['admin:tripproject:update']"
                    @click="$emit('TripProjectClick', row.trip_id)">
                    行程项目
                </a-button>
                <a-button type="link" style="color: red;" class="p-5" v-permission="['admin:trip:tripover']"
                    @click="$emit('TripOverClick', row.trip_id)">
                    结束&评分&改状态
                </a-button>
                <a-button type="link" style="color: red;" class="p-5" v-permission="['admin:trip:delete']"
                    @click="$emit('TripDeleteClick', row.trip_id)">
                    删除行程
                </a-button>
            </template>
        </a-table>
    </div>
</template>
<script>

//获取今天日期 yyyy-MM-dd
function getDate() {
    var date = new Date();
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var day = date.getDate();
    if (month < 10) {
        month = "0" + month;
    }
    if (day < 10) {
        day = "0" + day;
    }
    return year + "-" + month + "-" + day;
}
export default {
    props: {
        x: {
            type: Number,
            default: 1400
        },
        y: {
            type: [Number, Boolean],
            default: false
        },
        columns: {
            type: Array,
            default: () => {
                return []
            }
        },
        dataList: {
            type: Array,
            default: () => {
                return []
            }
        },
        dataListLoading: {
            type: Boolean,
            default: () => {
                return false
            }
        },
    },
    data() {
        return {
            todaytext: getDate()
        }
    },
}
</script>